import type { UserFocus } from '@/hooks/use-focus-store'

export type FocusRouteAction = 'render' | 'switch' | 'redirect'

export interface FocusRouteActionInput {
  routeFocus: string
  userFocus: Pick<UserFocus, 'current_focus' | 'available_foci' | 'role_switching_enabled'>
  roleSwitchingEnabled: boolean
  /**
   * The gate already rendered this route. A focus change after that is the user switching
   * away (sidebar), so it redirects instead of switching back.
   */
  entered: boolean
  switchFailed: boolean
}

/** What a focus route (the tree mounted at a focus root) does for the user's current focus. */
export function focusRouteAction({
  routeFocus,
  userFocus,
  roleSwitchingEnabled,
  entered,
  switchFailed,
}: FocusRouteActionInput): FocusRouteAction {
  const holdsRole = userFocus.available_foci.includes(routeFocus)
  if (holdsRole && userFocus.current_focus === routeFocus) return 'render'
  const canSwitch =
    holdsRole && roleSwitchingEnabled && userFocus.role_switching_enabled !== false
  if (canSwitch && !entered && !switchFailed) return 'switch'
  return 'redirect'
}
